import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppointmentCase } from '@quorum/models/xs-resource';
import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import { map, tap } from 'rxjs/operators';
import {
  AppointmentCasesEntityActionTypes,
  CreateAppointmentCaseOnServer,
  CreateAppointmentCaseOnServerError,
  CreateAppointmentCaseOnServerSuccess,
  DeleteAppointmentCaseOnServer,
  DeleteAppointmentCaseOnServerError,
  DeleteAppointmentCaseOnServerSuccess,
  GetAppointmentCasesFromServer,
  GetAppointmentCasesFromServerError,
  GetAppointmentCasesFromServerSuccess,
  UpdateAppointmentCaseOnServer,
  UpdateAppointmentCaseOnServerError,
  UpdateAppointmentCaseOnServerSuccess,
} from './appointment-cases.actions';

@Injectable()
export class AppointmentCasesEntityEffects {

  getSelectedAppointmentCasesFromServer = createEffect(() => this.dataPersistence.fetch(
    AppointmentCasesEntityActionTypes.GetAppointmentCasesFromServer,
    {
      run: (action: GetAppointmentCasesFromServer, state: any) => {
        return this.apiService
          .get<AppointmentCase[]>(`v/1/fixed-operations/appointment-cases`, {
            params: action.payload.params,
          })
          .pipe(
            map((appointmentCases) => {
              return new GetAppointmentCasesFromServerSuccess(appointmentCases);
            })
          );
      },
      onError: (action: GetAppointmentCasesFromServer, error) => {
        console.error('Error', error);
        return new GetAppointmentCasesFromServerError(error);
      },
    }
  ));


  updateAppointmentCaseOnServer = createEffect(() => this.dataPersistence.fetch(
    AppointmentCasesEntityActionTypes.UpdateAppointmentCaseOnServer,
    {
      run: (action: UpdateAppointmentCaseOnServer, state: any) => {
        return this.apiService
          .put<AppointmentCase>(
            `v/1/fixed-operations/appointment-cases/${action.payload.appointmentId}/${action.payload.sequence}`,
            action.payload,
            {
              params: {
                embed: 'warrantySubmissionType',
              },
            }
          )
          .pipe(
            map((appointmentCase) => {
              return new UpdateAppointmentCaseOnServerSuccess(appointmentCase);
            })
          );
      },
      onError: (action: UpdateAppointmentCaseOnServer, error) => {
        console.error('Error', error);
        return new UpdateAppointmentCaseOnServerError(error);
      },
    }
  ));


  deleteAppointmentCaseOnServer = createEffect(() => this.dataPersistence.fetch(
    AppointmentCasesEntityActionTypes.DeleteAppointmentCaseOnServer,
    {
      run: (action: DeleteAppointmentCaseOnServer, state: any) => {
        return this.apiService
          .delete<AppointmentCase>(
            `v/1/fixed-operations/appointment-cases/${action.payload.appointmentId}/${action.payload.sequence}?removeWorkOrderCase=false`,
            action.payload
          )
          .pipe(
            map((appointmentCase) => {
              return new DeleteAppointmentCaseOnServerSuccess(action.payload);
            })
          );
      },
      onError: (action: DeleteAppointmentCaseOnServer, error) => {
        console.error('Error', error);
        return new DeleteAppointmentCaseOnServerError(error);
      },
    }
  ));


  createAppointmentCaseOnServer = createEffect(() => this.dataPersistence.fetch(
    AppointmentCasesEntityActionTypes.CreateAppointmentCaseOnServer,
    {
      run: (action: CreateAppointmentCaseOnServer, state: any) => {
        return this.apiService
          .post<AppointmentCase[]>(`v/1/fixed-operations/appointment-cases`, action.payload.appointmentCase, {
            params: {
              embed: 'warrantySubmissionType,serviceGroup',
            },
          })
          .pipe(
            map((appointmentCase) => {
              return new CreateAppointmentCaseOnServerSuccess({
                appointmentCase: appointmentCase,
                quoteLine: action.payload.quoteLine,
              });
            })
          );
      },
      onError: (action: CreateAppointmentCaseOnServer, error) => {
        console.error('Error', error);
        return new CreateAppointmentCaseOnServerError(error);
      },
    }
  ));

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<any>,
    private apiService: ApiService,
    private router: Router
  ) {}
}
